
<template>
  
  <v-app id="searchBtodExported">
    <v-main>
     <v-container fluid>
       <v-row no-gutters>
        <v-card class="px-2">
         
             <v-btn v-if="items.length > 0" class="primary mx-2" x-small @click="setBtodToNew()">Import ABN failed. Set orders to 'New'</v-btn> 

            <v-text-field
            v-model="search"
              label="Search"
              single-line
              hide-details
             >
            </v-text-field>
        
            <v-data-table 
            :items="items" 
            :items-per-page="50" 
            :footer-props="{'items-per-page-options': [50, 100, 200, 300, 500]}"
            :headers="headers"
            :search="search"        
            >
            <template v-slot:item="props">
              <tr>
              <td>{{props.item.btod_aan_type}} </td>
              <td>{{props.item.btod_aan_oms}} </td>
              <td>{{props.item.btod_ref_type}} </td>
              <td>{{props.item.btod_ref_oms}} </td>
              <td align="right">{{props.item.btod_bedrag}} </td>
              <td>{{props.item.btod_batch_code}} </td>
              </tr>
            </template>
            </v-data-table>
        </v-card>
        </v-row>
        <btodToNew ref="btodToNew"></btodToNew>
     </v-container>
    
    </v-main>
    <navBar :title="'Ares - Finance'" :home="true" type="finance"/>
  </v-app>
</template>

<script>
import navBar from "@/components/ui/navbars/navbar.vue";
import btodToNew from "@/views/task/fin/abn/btodToNew";

 export default {
  components: {
    navBar,
    btodToNew
  },
  data() {
    return {
      items: [],
      search: '',
      headers: [
        {text: 'Type', value: 'btod_aan_type'},
        {text: 'Description', value: 'btod_aan_oms'},
        {text: 'Ref. Type', value: 'btod_ref_type'},
        {text: 'Ref. Description', value: 'btod_ref_oms'},
        {text: 'Amount', align: 'end', value: 'btod_bedrag'},
        {text: 'ARES Batch', value: 'btod_batch_code'}
      ]
    }

  },
  mounted() {
      this.results = true;
      console.log(this.$route.fullPath)
      this.$axios
        .post("ares/json/ares/task/fin/abn/searchBtod.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "searchBtod"
          },
          searchBtod: {
            stat: 'exported'
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            console.log(res.data.searchBtod); 
            this.items = res.data.searchBtod;
          }
        })
        .finally(() => {
          this.loading = false;
        });
  },
  methods: {
    setBtodToNew() {
       this.$refs.btodToNew.open();
    }
  }
}

</script> 
